$(document).on('keyup', '.dnFormTextarea-autoGrow', function () {

    if ((this.clientHeight) < this.scrollHeight) {
        this.style.height = this.scrollHeight +  "px";
    }
});

$(document).on('focus', '.dnFormTextarea-autoExpand', function () {

    var currentHeight = $(this).outerHeight();

    if (!$(this).attr('data-height-default')) {
        $(this).attr('data-height-default', currentHeight);
    }

    if (this.scrollHeight > currentHeight) {
        $(this).css('height', this.scrollHeight);
    }
});

$(document).on('focusout', '.dnFormTextarea-autoExpand', function () {
    var heightDefault = $(this).attr('data-height-default');
    $(this).css('height', heightDefault);
});
